import styled from '@emotion/styled'

const PlaidButton = styled.button`
  font-size: 14px;
  color: ${p => p.theme.editColor};
  cursor: pointer;
  background-color: transparent !important;
  text-decoration: underline;
  border: none;
`

export default PlaidButton
